import { motion } from "framer-motion";
import { Heart } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "text-binky-blue" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] sm:text-sm ${className}`}
  >
    <Heart className="h-3.5 w-3.5 fill-current" />
    {children}
  </span>
);
